import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { UsecasepageService } from '../usecasepage.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { ModalComponent } from 'src/app/custom-component/modal/modal.component';
import { TalkToSalesButtonComponent } from 'src/app/shared/components/talktosalesButton/talktosalesButton.component';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-usecases-hero',
  templateUrl: './usecases-hero.component.html',
  styleUrls: ['./usecases-hero.component.scss'],
  imports: [CommonModule, ToHtmlPipe, TalkToSalesButtonComponent, UrlParamsPipe],
})
export class UsecasesHeroComponent implements OnInit, OnDestroy {
  @ViewChild('registerLink') registerLink: any;
  @Input() pageData: any;
  queryParams: any;
  constructor(private usecasepageService: UsecasepageService,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  heroData: any;

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    if (!this.pageData || !this.pageData.fields) {
      return;
    }
    
    const data = this.pageData.fields;
    if (data != null) {
        let hero = data?.heroContentPanel?.fields;
        if (hero) {
          this.heroData = {
            badge: hero.components?.[0]?.fields?.tagText,
            header: hero.title,
            paragraph: hero.content,
            image: {
              url: hero.image?.[0]?.fields?.file?.url,
              alt: hero.image?.[0]?.fields?.title,
            },
            button1: {
              text: hero.buttons?.[0]?.fields?.buttonText,
              url: hero.buttons?.[0]?.fields?.redirectLink,
              target: hero.buttons?.[0]?.fields?.actionType,
            },
            button2: {
              text: hero.buttons?.[1]?.fields?.buttonText,
              url: hero.buttons?.[1]?.fields?.redirectLink,
              target: hero.buttons?.[1]?.fields?.actionType,
            },
          };
        }
      }
  }
}
